/* hs-suche.js, 22.10.2026 (Auftrag David). Suche im Shop gezielter machen.
   1. Beim Antippen des Suchfelds erscheinen sofort Vorschläge (Gerätearten und Marken).
   2. Erkennt die Eingabe eine Geräteart und eine Marke (z. B. «waschmaschine bosch»), führt die Suche direkt
      zur passenden Kategorie mit Markenfilter, also nur Waschmaschinen von Bosch. In der Vorschlagsliste steht
      dieser Treffer zuoberst.
   3. Nur Geräteart: direkt zur Kategorie. Nur Marke: zur Markenseite. Sonst normale Shopify Suche. */
(function () {
  var ART = [
    [/waschmaschine|waschautomat|waschger(ä|ae)t|\bwaschen\b/, 'waschmaschinen', 'Waschmaschinen'],
    [/w(ä|ae)schetrockner|trockner|tumbler/, 'waeschetrockner', 'Wäschetrockner'],
    [/waschset|wasch-set|waschturm/, 'waschsets', 'Waschsets'],
    [/trockenschrank/, 'trockenschraenke', 'Trockenschränke'],
    [/geschirrsp(ü|ue)ler|sp(ü|ue)lmaschine|abwaschmaschine|\bsp(ü|ue)ler\b/, 'geschirrspueler', 'Geschirrspüler'],
    [/k(ü|ue)hl.?gefrier|kombination/, 'kuehl-gefrier-kombinationen', 'Kühl-Gefrier-Kombinationen'],
    [/gefrier|tiefk(ü|ue)hl/, 'gefrierschraenke', 'Gefrierschränke'],
    [/wein/, 'weinschraenke', 'Weinschränke'],
    [/k(ü|ue)hlschrank|k(ü|ue)hlger(ä|ae)t|k(ü|ue)hlen/, 'kuehlschraenke', 'Kühlschränke'],
    [/kombisteamer|steamer|dampfgarer/, 'kombisteamer', 'Kombisteamer'],
    [/backofen|back(ö|oe)fen|\bofen\b/, 'backoefen', 'Backöfen'],
    [/herdset|\bherd\b|einbauherd/, 'herde', 'Einbauherde'],
    [/kochfeld|induktion|glaskeramik/, 'kochfelder', 'Kochfelder']
  ];
  var MARKE = [
    ['asko', 'ASKO', '/pages/asko'], ['bosch', 'Bosch', '/collections/marke-bosch'], ['siemens', 'Siemens', '/collections/marke-siemens'],
    ['electrolux', 'Electrolux', '/collections/marke-electrolux'], ['aeg', 'AEG', '/collections/marke-aeg'], ['miele', 'Miele', '/collections/marke-miele'],
    ['v-?zug|vzug', 'V-ZUG', '/collections/marke-v-zug'], ['schulthess', 'Schulthess', '/collections/marke-schulthess'],
    ['liebherr', 'Liebherr', '/collections/marke-liebherr'], ['fors', 'FORS', '']
  ];
  var VORSCHLAG = [
    ['/collections/waschmaschinen', 'Waschmaschinen'], ['/collections/waeschetrockner', 'Wäschetrockner'],
    ['/collections/geschirrspueler', 'Geschirrspüler'], ['/collections/kuehlschraenke', 'Kühlschränke'],
    ['/collections/backoefen', 'Backöfen'], ['/collections/kochfelder', 'Kochfelder'],
    ['/collections/elite-exklusivmodelle', 'ELITE Exklusivmodelle'], ['/collections/preisvorteile', 'Angebote']
  ];
  var MARKEN_LINKS = [['/pages/asko', 'ASKO'], ['/collections/marke-bosch', 'Bosch'], ['/collections/marke-siemens', 'Siemens'],
    ['/collections/marke-electrolux', 'Electrolux'], ['/collections/marke-v-zug', 'V-ZUG'], ['/collections/marke-miele', 'Miele']];

  function deuten(q) {
    var t = (q || '').toLowerCase().trim();
    if (!t) return null;
    var art = null, marke = null, i;
    for (i = 0; i < ART.length; i++) if (ART[i][0].test(t)) { art = ART[i]; break; }
    for (i = 0; i < MARKE.length; i++) if (new RegExp('\\b(' + MARKE[i][0] + ')\\b').test(t)) { marke = MARKE[i]; break; }
    if (!art && !marke) return null;
    /* Weitere Wörter (z. B. Modellnummer) vorhanden: normale Suche ist genauer */
    var rest = t;
    if (art) rest = rest.replace(art[0], ' ');
    if (marke) rest = rest.replace(new RegExp('\\b(' + marke[0] + ')\\b'), ' ');
    rest = rest.replace(/\b(von|der|die|das|und|mit|für|fuer|kaufen|günstig|guenstig|preis|cm|60|55)\b/g, ' ').replace(/[^a-z0-9äöü]+/g, ' ').trim();
    if (rest.length > 2) return null;
    if (art && marke) return { url: '/collections/' + art[1] + '?filter.p.vendor=' + encodeURIComponent(marke[1]), text: art[2] + ' von ' + marke[1] };
    if (art) return { url: '/collections/' + art[1], text: 'Alle ' + art[2] };
    return { url: marke[2] || ('/search?q=' + encodeURIComponent('vendor:"' + marke[1] + '"') + '&type=product'), text: 'Alles von ' + marke[1] };
  }

  function stil() {
    if (document.getElementById('hs-suche-stil')) return;
    var s = document.createElement('style'); s.id = 'hs-suche-stil';
    s.textContent = '.hs-suche-box{flex:0 0 100%;width:100%;order:5}.hs-suche-tipps{padding:18px 0 6px;font-size:15px}.hs-suche-tipps h4{font-size:11px;letter-spacing:.18em;text-transform:uppercase;margin:0 0 10px;color:#777;font-weight:600}' +
      '.hs-suche-tipps ul{list-style:none;margin:0 0 16px;padding:0;display:flex;flex-wrap:wrap;gap:8px}.hs-suche-tipps a{display:inline-block;padding:7px 13px;border:1px solid #e3e0d8;background:#faf9f6;color:#111;text-decoration:none}' +
      '.hs-suche-tipps a:hover{background:#111;color:#fff;border-color:#111}.hs-suche-treffer{display:block;margin:12px 0 4px;padding:12px 16px;background:#111;color:#fff !important;text-decoration:none;font-weight:600}' +
      '.hs-suche-treffer span{font-weight:400;opacity:.75;margin-left:8px}';
    document.head.appendChild(s);
  }
  function tippsHtml() {
    function li(a) { return '<li><a href="' + a[0] + '">' + a[1] + '</a></li>'; }
    return '<div class="hs-suche-tipps"><h4>Häufig gesucht</h4><ul>' + VORSCHLAG.map(li).join('') + '</ul><h4>Marken</h4><ul>' + MARKEN_LINKS.map(li).join('') + '</ul></div>';
  }

  function einrichten(form) {
    if (form.dataset.hsSuche) return;
    form.dataset.hsSuche = '1';
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var box = document.createElement('div'); box.className = 'hs-suche-box';
    var ziel = form.querySelector('.search__results') || form;
    ziel.parentNode.insertBefore(box, ziel);
    function zeigen() {
      var v = input.value.trim();
      if (!v) { box.innerHTML = tippsHtml(); return; }
      var d = deuten(v);
      box.innerHTML = d ? '<a class="hs-suche-treffer" href="' + d.url + '">' + d.text + '<span>direkt anzeigen</span></a>' : '';
    }
    /* Vorschlagsliste von Shopify: bei erkannter Marke und Geräteart nur passende Geräte zeigen, «Alle Ergebnisse» führt zur gefilterten Kategorie */
    var liste = form.querySelector('.search__results');
    if (liste) new MutationObserver(function () {
      var t = input.value.toLowerCase(), d = deuten(t), m = null, a = null, i;
      if (!d) return;
      for (i = 0; i < MARKE.length; i++) if (new RegExp('\\b(' + MARKE[i][0] + ')\\b').test(t)) { m = MARKE[i]; break; }
      for (i = 0; i < ART.length; i++) if (ART[i][0].test(t)) { a = ART[i]; break; }
      liste.querySelectorAll('a[href*="/products/"]').forEach(function (el) {
        var txt = (el.textContent || '').toLowerCase();
        var passt = (!m || new RegExp('\\b(' + m[0] + ')\\b').test(txt)) && (!a || a[0].test(txt));
        var zeile = el.closest('li') || el;
        zeile.style.display = passt ? '' : 'none';
      });
      liste.querySelectorAll('a[href*="/search"]').forEach(function (el) { if (el.getAttribute('href') !== d.url) { el.setAttribute('href', d.url); el.textContent = d.text + ' anzeigen →'; } });
    }).observe(liste, { childList: true, subtree: true });
    input.addEventListener('focus', zeigen);
    input.addEventListener('input', zeigen);
    form.addEventListener('submit', function (e) {
      var d = deuten(input.value);
      if (d) { e.preventDefault(); e.stopImmediatePropagation(); location.href = d.url; }
    }, true);
    if (document.activeElement === input) zeigen();
  }
  function alle() { stil(); document.querySelectorAll('form[action*="/search"]').forEach(einrichten); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  /* Beim Öffnen der Suche im Kopfbereich gleich die Vorschläge zeigen */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.js-search-header')) setTimeout(function () {
      var i = document.querySelector('.site-header__search input[name="q"]'); if (i) i.dispatchEvent(new Event('focus'));
    }, 150);
  });
})();
